import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import locales from "../../../_constants/locales";
import "../styles/RelatedTickets.css";

class RelatedTicketsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    handleClick(ticketId) {
        window.open(`${process.env.PUBLIC_URL}/tickets?id=${ticketId}`, "_blank", "noreferrer");
    }

    getLogStatusTitle(code) {
        if (locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS[code]) {
            return locales[this.props.language.code].TICKET.REQUEST_DETAILS.STATUS[code].TITLE;
        } else {
            return code;
        }
    }

    render() {
        return (
            <div className="flex layout vertical related-tickets section">
                <div className="flex layout horizontal center section-header">
                    <div className="layout horizontal center title-row">
                        <h2 className="title">{locales[this.props.language.code].TICKET.RELATED_TICKETS.TITLE}</h2>
                    </div>
                </div>
                <div className="flex layout vertical section-body">
                    <table className="related-tickets-table">
                        <thead>
                            <tr className="request related-tickets-table-header-row">
                                <th className="related-tickets-table-header-cell">
                                    <p>{locales[this.props.language.code].TICKET.RELATED_TICKETS.TICKET_NUMBER}</p>
                                </th>
                                <th className="related-tickets-table-header-cell">
                                    <p>{locales[this.props.language.code].TICKET.RELATED_TICKETS.CREATED_DATE}</p>
                                </th>
                                <th className="related-tickets-table-header-cell desktop-only">
                                    <p>{locales[this.props.language.code].TICKET.RELATED_TICKETS.REQUEST_TYPES}</p>
                                </th>
                                <th className="related-tickets-table-header-cell">
                                    <p>{locales[this.props.language.code].TICKET.RELATED_TICKETS.STATUS}</p>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {_.orderBy(this.props.relatedTickets, ["createdAt"], ["desc"]).map((relatedTicket, i) => {
                                let isCurrentTicket = relatedTicket.ticketNumber === this.props.ticketNumber;
                                let rowClassName = `request related-tickets-table-row${isCurrentTicket ? " current" : ""}`;
                                let cellClassName = `related-tickets-table-cell${isCurrentTicket ? " current" : ""}`;
                                let ariaLabel = `${locales[this.props.language.code].TICKET.RELATED_TICKETS.TICKET_NUMBER} ${relatedTicket.ticketNumber}`;

                                return (
                                    <tr className={rowClassName} key={i}>
                                        {isCurrentTicket ? (
                                            <td className={`${cellClassName}`}>
                                                <p className="action-button disabled">{relatedTicket.ticketNumber}</p>
                                            </td>
                                        ) : (
                                            <td className={`${cellClassName}`}>
                                                <a
                                                    className="action-button"
                                                    aria-label={ariaLabel}
                                                    href={`${process.env.PUBLIC_URL}/tickets?id=${relatedTicket.id}`}
                                                    target="_blank"
                                                >
                                                    {relatedTicket.ticketNumber}
                                                </a>
                                            </td>
                                        )}

                                        <td className={`${cellClassName}`}>
                                            <p>{moment(new Date(relatedTicket.createdAt)).locale(this.props.language.code.toLowerCase()).format("ll")}</p>
                                        </td>
                                        <td className={`${cellClassName} desktop-only`}>
                                            <p>{relatedTicket.requests.map(r => r.requestType.label).join(", ")}</p>
                                        </td>
                                        <td className={`${cellClassName}`}>
                                            <p>{this.getLogStatusTitle(relatedTicket.latestStatus)}</p>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}

export default withRouter(RelatedTicketsSection);
